export default "__VITE_ASSET__Bd8vsM7W__"